<template>
  <div class="wrapper">
    <div class="container">
      <img src="@/assets/images/banner.png" class="banner" />
      <div class="section">
        <!-- // 系统状态 未提交过基本信息 返回null  [1090-待提交资质、1110-待初审、1111-初审失败、1130-易宝待审核、1131-易宝审核成功、1132-易宝审核失败、2001营业中(入驻成功)] -->
        <!-- 审核中 -->
        <p v-if="distributionType!=1&&(distributionInfo.systemStatus===1110||distributionInfo.systemStatus===1130)">您的申请正在审核中，请您耐心等待~</p>
        <template v-if="distributionType==1&&(distributionInfo.systemStatus===1110||distributionInfo.systemStatus===1130)">
          <p>您的申请正在审核中，请您耐心等待~</p>
          <p>您也可以现在就下载管理APP。审核通过后，会为您提供全部的功能。</p>
        </template>
        <!-- 审核失败 -->
        <template v-if="distributionInfo.systemStatus===1111||distributionInfo.systemStatus===1132">
          <p>很抱歉，因您的资质等问题，您的申请已经被驳回~</p>
          <p v-if="distributionInfo.rejectReason">拒绝原因：{{distributionInfo.rejectReason}}</p>
        </template>
        <!-- 审核成功-->
        <p v-if="distributionInfo.systemStatus===1131||distributionInfo.systemStatus===2001">您的申请已经通过。</p>
      </div>
      <!-- <div class="section code-section">
        <van-image class="code-img"
          width="5rem"
          height="5rem"
          fit="contain"
          src="https://img01.yzcdn.cn/vant/apple-1.jpg"
          @click="toPreviewImg"
        />
        <div class="code-img"></div>
        <div class="code-info">
          <h4>下载客户端</h4>
          <p>手机扫一扫</p>
        </div>
      </div> -->
      <div class="section account-section" v-if="distributionType==1"> 
        <div class="row" v-if="account">
          <span class="label-name">账号</span>
          <span class="account-info">{{account}}<span class="copy-btn" v-clipboard:copy="account" v-clipboard:success="onCopySuccess" v-clipboard:error="onCopyError">复制</span></span>
        </div>
        <div class="row" v-if="password">
          <span class="label-name">初始密码</span>
          <span class="account-info">{{password}}<span class="copy-btn" v-clipboard:copy="password" v-clipboard:success="onCopySuccess" v-clipboard:error="onCopyError">复制</span></span>
        </div>
      </div>
      <div class="section link-section" v-if="distributionType==1">
        <a href="https://pc.qdsd398.com/admin" class="link-url">https://pc.qdsd398.com/admin</a>
        <span class="copy-btn" v-clipboard:copy="'https://pc.qdsd398.com/admin'" v-clipboard:success="onCopySuccess" v-clipboard:error="onCopyError">复制</span>
      </div>
    </div>
    <div class="footer-bar"></div>
    <div class="footer">
      <!-- 审核失败 -->
      <router-link :to="{path: '/distribution/baseinfo-auth'}" class="btn upload-btn pc-upload-btn" v-if="distributionInfo.systemStatus===1111||distributionInfo.systemStatus===1132">重新提交资质</router-link>
  
      <template v-if="distributionType==1">
        <router-link :to="{path: '/distribution/download'}" class="btn upload-btn pc-upload-btn">下载客户端app</router-link>
        <div class="btn upload-btn m-upload-btn" @click="openLink">下载客户端app</div>
        <!-- <a href="javascripe:void(0);" class="btn upload-btn m-upload-btn" @click="openLink">下载客户端app</a> -->
      </template>
    </div>
    <ContactBtn />
  </div>
</template>


<script>
import { getLoginUser } from '@/api/user';
import { getLoginDistributionInfo } from '@/api/distribution/index';
export default {
  name: 'apply-results',
  data () {
    return {
      userCode: sessionStorage.getItem('userCode')||null,
      shopCode: sessionStorage.getItem('shopCode')||null,
      distributionType: sessionStorage.getItem('distributionType')||null,
      account: null,
      password: null,
      distributionInfo: {}
    }
  },
  created() {
    this.getLoginUser();
    this.getDistributionInfo();
    console.log(this.distributionType)
    console.log(sessionStorage.getItem('distributionType'))
    console.log(sessionStorage.getItem('shopCode'))
    console.log(sessionStorage.getItem('userCode'))
  },
  methods: {
    onCopySuccess() {
      this.Toast('复制成功');
    },
    onCopyError() {
      this.Toast('抱歉，复制失败！');
    },
    getLoginUser() {
      getLoginUser().then(res => {
        if(res.code === 200) {
          this.account = res.data.userTel;
          this.password = this.account.substring(this.account.length,this.account.length-6)
        }
      })
    },
    getDistributionInfo() {
      getLoginDistributionInfo({"userCode":this.userCode,"shopCode":this.shopCode}).then(res => {
        if(res.code === 200&&res.data) {
          this.distributionInfo = res.data.distributionInfo;
          this.distributionInfo.systemStatus = Number(this.distributionInfo.systemStatus);
        }
      })
    },
    openLink() {
      var ua = navigator.userAgent.toLowerCase();  
      if(ua.match(/MicroMessenger/i)=="micromessenger") {
        alert('请在浏览器打开');
      } else {
        this.$router.push({
          path: '/distribution/download'
        })
        // window.open('https://apps.apple.com/app/id1644578076');
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@media screen and (max-width:750px){
  .container{
    padding-top: .05rem;
    position: relative;
  }
  .banner{
    width: 16.7rem;
    height: 8.2rem;
    display: block;
    margin: .5rem auto 1.2rem;
    border-radius: .8rem;
  }
  .section{
    width: 16.7rem;
    margin: 0 auto 1.2rem;
    p{
      line-height: 1.5;
      font-size: .7rem;
      color: #222;
      text-align: left;
      margin-bottom: .25rem;
    }
  }
  .code-section{
    background: #F5F5F7;
    border-radius: .8rem;
    padding: 1.5rem;
    box-sizing: border-box;
    @include flex-align();
    .code-img{
      width: 5rem;
      height: 5rem;
      background: #eee;
      cursor: pointer;
    }
    .code-info{
      margin-left: 1rem;
      h4{
        font-size: 1.1rem;
        font-weight: 400;
        color: #222222;
      }
      p{
        font-size: .8rem;
        color: #999999;
        margin-top: .35rem;
      }
    }
  }
  .account-section{
    .row{
      margin-bottom: .15rem;
      @include flex-align();
      .label-name{
        width: 3rem;
        font-size: .7rem;
        color: #999;
      }
      .account-info{
        margin-left: .9rem;
        font-size: .7rem;
        color: #222;
        .copy-btn{
          font-size: .7rem;
          color: $base-color;
          margin-left: .3rem;
          cursor: pointer;;
        }
      }
    }
  }
  .link-section{
    background: #F5F5F7;
    border-radius: .8rem;
    padding: 1rem .8rem;
    box-sizing: border-box;
    @include flex(space-between);
    .link-url{
      font-size: .7rem;
      color: #3780D4;
    }
    .copy-btn{
      font-size: .7rem;
      color: $base-color;
      margin-left: .3rem;
      cursor: pointer;;
    }
  }
  .footer{
    width: 16.75rem;
    height: 2.2rem;
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    z-index: 3;
    .btn{
      width: 8rem;
      height: 2.2rem;
      line-height: 2.15rem;
      background: #47B6C7;
      border-radius: .4rem;
      font-size: .8rem;
      color: #fff;
      text-align: center;
      cursor: pointer;
      margin: 0 auto;
    }
  }
  .pc-upload-btn{
    display: none;
  }
  .m-upload-btn{
    display: inline-block;
  }
}
@media screen and (min-width:750px){
  .banner{
    width: 334px;
    height: 164px;
    display: block;
    margin: 10px auto 24px;
    border-radius: 16px;
  }
  .section{
    width: 334px;
    margin: 0 auto 24px;
    p{
      line-height: 1.5;
      font-size: 14px;
      color: #222;
      text-align: left;
      margin-bottom: 5px;
    }
  }
  .code-section{
    background: #F5F5F7;
    border-radius: 16px;
    padding: 30px;
    box-sizing: border-box;
    @include flex-align();
    .code-img{
      width: 100px;
      height: 100px;
      background: #eee;
      cursor: pointer;
    }
    .code-info{
      margin-left: 20px;
      h4{
        font-size: 22px;
        font-weight: 400;
        color: #222222;
      }
      p{
        font-size: 16px;
        color: #999999;
        margin-top: 7px;
      }
    }
  }
  .account-section{
    .row{
      margin-bottom: 3px;
      @include flex-align();
      .label-name{
        width: 60px;
        font-size: 14px;
        color: #999;
      }
      .account-info{
        margin-left: 18px;
        font-size: 14px;
        color: #222;
        .copy-btn{
          font-size: 14px;
          color: $base-color;
          margin-left: 6px;
          cursor: pointer;;
        }
      }
    }
  }
  .link-section{
    background: #F5F5F7;
    border-radius: 16px;
    padding: 20px 16px;
    box-sizing: border-box;
    @include flex(space-between);
    .link-url{
      font-size: 14px;
      color: #3780D4;
    }
    .copy-btn{
      font-size: 14px;
      color: $base-color;
      margin-left: 6px;
      cursor: pointer;;
    }
  }
  .footer{
    width: 335px;
    //height: 44px;
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    padding: 20px 20px 30px;
    z-index: 3;
    .btn{
      width: 160px;
      height: 44px;
      line-height: 43px;
      background: #47B6C7;
      border-radius: 8px;
      font-size: 16px;
      color: #fff;
      text-align: center;
      cursor: pointer;
      margin: 0 auto;
    }
  }
  .pc-upload-btn{
    display: inline-block;
  }
  .m-upload-btn{
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/distribution/apply-results.vue